export enum Nationality {
  AFG = 'AFG',

  ALB = 'ALB',

  DZA = 'DZA',

  USA = 'USA',

  AGO = 'AGO',

  ARG = 'ARG',

  AUS = 'AUS',

  AUT = 'AUT',

  AND = 'AND',

  ALD = 'ALD',

  ATG = 'ATG',

  ARM = 'ARM',

  AZE = 'AZE',

  AIA = 'AIA',

  ANT = 'ANT',

  ATF = 'ATF',

  AWB = 'AWB',

  ASM = 'ASM',

  BHS = 'BHS',

  BHR = 'BHR',

  BGD = 'BGD',

  BRB = 'BRB',

  BEL = 'BEL',

  BMU = 'BMU',

  BOL = 'BOL',

  BWA = 'BWA',

  BRA = 'BRA',

  GBR = 'GBR',

  B13 = 'B13',

  BRN = 'BRN',

  BGR = 'BGR',

  MMR = 'MMR',

  B17 = 'B17',

  BEN = 'BEN',

  BDI = 'BDI',

  BTN = 'BTN',

  BLZ = 'BLZ',

  BFA = 'BFA',

  BIH = 'BIH',

  BLR = 'BLR',

  BVT = 'BVT',

  GBN = 'GBN',

  KHM = 'KHM',

  CMR = 'CMR',

  CAN = 'CAN',

  C04 = 'C04',

  CYM = 'CYM',

  CAF = 'CAF',

  LKA = 'LKA',

  TCD = 'TCD',

  CHL = 'CHL',

  CHN = 'CHN',

  COL = 'COL',

  COG = 'COG',

  CRI = 'CRI',

  CUB = 'CUB',

  C15 = 'C15',

  CYP = 'CYP',

  CZE = 'CZE',

  CPV = 'CPV',

  COM = 'COM',

  COK = 'COK',

  HRV = 'HRV',

  CCK = 'CCK',

  CXR = 'CXR',

  COD = 'COD',

  D02 = 'D02',

  DNK = 'DNK',

  DOM = 'DOM',

  NLD = 'NLD',

  DIM = 'DIM',

  D07 = 'D07',

  DJI = 'DJI',

  DMA = 'DMA',

  E01 = 'E01',

  ECU = 'ECU',

  EGY = 'EGY',

  ETH = 'ETH',

  SLV = 'SLV',

  GNQ = 'GNQ',

  EST = 'EST',

  ERI = 'ERI',

  TMP = 'TMP',

  FRO = 'FRO',

  FJI = 'FJI',

  FIN = 'FIN',

  FRA = 'FRA',

  FLK = 'FLK',

  FXX = 'FXX',

  GAB = 'GAB',

  GMB = 'GMB',

  DEU = 'DEU',

  GHA = 'GHA',

  GRC = 'GRC',

  GRL = 'GRL',

  GLP = 'GLP',

  GTM = 'GTM',

  GIN = 'GIN',

  GUY = 'GUY',

  GUM = 'GUM',

  GRD = 'GRD',

  GNB = 'GNB',

  GEO = 'GEO',

  GIB = 'GIB',

  GUF = 'GUF',

  HTI = 'HTI',

  HND = 'HND',

  HUN = 'HUN',

  HKG = 'HKG',

  HMD = 'HMD',

  ISL = 'ISL',

  IND = 'IND',

  IDN = 'IDN',

  IRN = 'IRN',

  IRQ = 'IRQ',

  IRL = 'IRL',

  ISR = 'ISR',

  ITA = 'ITA',

  CIV = 'CIV',

  IOT = 'IOT',

  JAM = 'JAM',

  JPN = 'JPN',

  JOR = 'JOR',

  KEN = 'KEN',

  KOR = 'KOR',

  KWT = 'KWT',

  KIR = 'KIR',

  PRK = 'PRK',

  KAZ = 'KAZ',

  KGZ = 'KGZ',

  RKS = 'RKS',

  LAO = 'LAO',

  LBN = 'LBN',

  LSO = 'LSO',

  LBR = 'LBR',

  LBY = 'LBY',

  LIE = 'LIE',

  LUX = 'LUX',

  LVA = 'LVA',

  LTU = 'LTU',

  MWI = 'MWI',

  MYS = 'MYS',

  MLI = 'MLI',

  MLT = 'MLT',

  MTQ = 'MTQ',

  MRT = 'MRT',

  MEX = 'MEX',

  MCO = 'MCO',

  MNG = 'MNG',

  MAR = 'MAR',

  MOZ = 'MOZ',

  FSM = 'FSM',

  MDV = 'MDV',

  MUS = 'MUS',

  MNP = 'MNP',

  MDG = 'MDG',

  MKD = 'MKD',

  MDA = 'MDA',

  TKM = 'TKM',

  MHL = 'MHL',

  MAC = 'MAC',

  MNE = 'MNE',

  MSR = 'MSR',

  MYT = 'MYT',

  NPL = 'NPL',

  N02 = 'N02',

  NZL = 'NZL',

  NIC = 'NIC',

  NER = 'NER',

  NGA = 'NGA',

  NOR = 'NOR',

  NRU = 'NRU',

  NAM = 'NAM',

  NCL = 'NCL',

  NFK = 'NFK',

  NIU = 'NIU',

  OMN = 'OMN',

  PAK = 'PAK',

  PLT = 'PLT',

  PAN = 'PAN',

  PNG = 'PNG',

  PRY = 'PRY',

  PER = 'PER',

  PHL = 'PHL',

  POL = 'POL',

  PRT = 'PRT',

  P10 = 'P10',

  PRI = 'PRI',

  PLW = 'PLW',

  PCN = 'PCN',

  PYF = 'PYF',

  QAT = 'QAT',

  REUv = 'REUv',

  ROU = 'ROU',

  RUS = 'RUS',

  RWA = 'RWA',

  SLB = 'SLB',

  SAU = 'SAU',

  STP = 'STP',

  SCT = 'SCT',

  SEN = 'SEN',

  SLE = 'SLE',

  SGP = 'SGP',

  SOM = 'SOM',

  ZAF = 'ZAF',

  ESP = 'ESP',

  S14 = 'S14',

  SDN = 'SDN',

  SUR = 'SUR',

  SWZ = 'SWZ',

  SWE = 'SWE',

  CHE = 'CHE',

  SYR = 'SYR',

  XXA = 'XXA',

  WSM = 'WSM',

  SYC = 'SYC',

  SMR = 'SMR',

  LCA = 'LCA',

  KNA = 'KNA',

  VCT = 'VCT',

  SVN = 'SVN',

  SVK = 'SVK',

  SGS = 'SGS',

  SHN = 'SHN',

  SJM = 'SJM',

  SPM = 'SPM',

  SRB = 'SRB',

  SSD = 'SSD',

  TWN = 'TWN',

  TZA = 'TZA',

  THA = 'THA',

  TGO = 'TGO',

  TTO = 'TTO',

  TUN = 'TUN',

  TUR = 'TUR',

  TON = 'TON',

  T10 = 'T10',

  TUV = 'TUV',

  TJK = 'TJK',

  TCA = 'TCA',

  TKL = 'TKL',

  TLS = 'TLS',

  UGA = 'UGA',

  URY = 'URY',

  ARE = 'ARE',

  XXX = 'XXX',

  UKR = 'UKR',

  UZB = 'UZB',

  UNO = 'UNO',

  UMI = 'UMI',

  UNA = 'UNA',

  UTO = 'UTO',

  VAT = 'VAT',

  VEN = 'VEN',

  VNM = 'VNM',

  VUT = 'VUT',

  VIS = 'VIS',

  WLF = 'WLF',

  XXB = 'XXB',

  XXC = 'XXC',

  YEM = 'YEM',

  YUG = 'YUG',

  Y03 = 'Y03',

  ZMB = 'ZMB',

  ZAR = 'ZAR',

  ZIM = 'ZIM',

  ZWE = 'ZWE',
}
